import { SwitchButton, TabItems } from '../../../../../../baseComponents/Button/SwitchButton'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useState } from 'react'
import NullComponent from '../../../../../../baseComponents/NullComponent'
import { BaseScreenTableSimple } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import SellStatsBody from './SellStatsBody'
import { TypeSellKeyTy } from './SellStatsBody/types'

interface SellAllStatsProps extends ComponentWithPermissions {}

const SellAllStats: React.FC<SellAllStatsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { typeSell, setTypeSell } = useSellAllStatsLogic()

    const pageData = {
        title: t('stats', 'Estadísticas'),
        newText: '',
    }
    return (
        <BaseScreenTableSimple TableComponent={SellStatsBody} extraTableProps={{typeSell}} {...{ pageData, userPermissions }} CreateModalComponent={NullComponent} RightHeader={<RightHeaderSellAllStats {...{ typeSell, setTypeSell }} />} whiteBoxClassName='skip_padding' />
    )
}

const useSellAllStatsLogic = () => {
    const [typeSell, setTypeSell] = useState<TypeSellKeyTy>(0)

    return { typeSell, setTypeSell }
}

interface RightHeaderSellAllStatsProps {
    typeSell: TypeSellKeyTy
    setTypeSell: React.Dispatch<React.SetStateAction<TypeSellKeyTy>>
 }

const RightHeaderSellAllStats: React.FC<RightHeaderSellAllStatsProps> = ({ typeSell, setTypeSell }) => {
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'quotes'}>Presupuestos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'sellOrders'}>Pedidos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'deliveryNotes'}>Albaranes</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'invoices'}>Facturas</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'tickets'}>Tickets</TwinTrans>
        },
    ]
    return (
        <SwitchButton className='mr-auto' onClick={(val) => setTypeSell(val as TypeSellKeyTy)} active={typeSell} items={items} />
    )
}


export default SellAllStats